/**
 * Atribución y fuentes — transparencia (reglas #7/#8/#9): de dónde viene la
 * información que muestra Faro VE + el opt-out canónico. Estática (el conteo total
 * se trae client-side como mejora progresiva) → se prerenderiza y precachea para
 * que funcione también sin conexión.
 */
export const prerender = true;
